"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Image = _interopRequireDefault(require("../Image"));

var _Text = _interopRequireDefault(require("../Text"));

var _UpsellBanner = _interopRequireDefault(require("./UpsellBanner.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "UpsellBanner__Wrapper",
  componentId: "sc-xwd2qz-0"
})(["width:", ";background:", ";", " box-sizing:border-box;", " border-radius:", ";display:flex;padding-top:", ";padding-right:", ";padding-bottom:", ";padding-left:", ";flex:1;cursor:pointer;overflow:hidden;"], function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? '100%' : 'fit-content';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor.secondaryLight;
}, function (_ref3) {
  var border = _ref3.border,
      theme = _ref3.theme;
  return border ? (0, _styledComponents.css)(["border:", " solid ", ";"], theme.space.micromini, theme.colors.secondaryLight) : (0, _styledComponents.css)(["border:'none';"]);
}, function (_ref4) {
  var hasBoxShadow = _ref4.hasBoxShadow,
      theme = _ref4.theme;
  return hasBoxShadow ? "box-shadow: ".concat(theme.space.none, " ").concat(theme.space.mini, "  ").concat(theme.space.micro, " rgba(0, 0, 0, 0.2);") : '';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.Xnormal;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.small;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.small;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.XSmall;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.small;
});

var Message = _styledComponents.default.div.withConfig({
  displayName: "UpsellBanner__Message",
  componentId: "sc-xwd2qz-1"
})(["padding-left:", ";& > *{display:block;}p{margin-bottom:", ";}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.tiny;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.tiny;
});

var LinkText = _styledComponents.default.p.withConfig({
  displayName: "UpsellBanner__LinkText",
  componentId: "sc-xwd2qz-2"
})(["margin-top:", ";font-family:", ";font-weight:", ";font-size:", ";color:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.tiny;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontFamily.default;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontWeight.large;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSize.small;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.tertiaryRed;
});

var LeftImage = _styledComponents.default.div.withConfig({
  displayName: "UpsellBanner__LeftImage",
  componentId: "sc-xwd2qz-3"
})(["position:relative;display:flex;margin-right:", ";max-width:", ";max-height:", ";"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.micro;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.semiLarge;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.semiLarge;
});

var UpsellBanner = function UpsellBanner(props) {
  var accessible = props.accessible,
      theme = props.theme,
      customProperties = props.customProperties,
      message = props.message,
      textType = props.textType,
      textColor = props.textColor,
      showLeftImage = props.showLeftImage,
      fullWidth = props.fullWidth,
      border = props.border,
      borderRadius = props.borderRadius,
      imageUrl = props.imageUrl,
      hasBoxShadow = props.hasBoxShadow,
      type = props.type;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var text = message.text,
      ctaText = message.ctaText;

  var handleOnClick = function handleOnClick() {
    var evt = new CustomEvent(_constant.UPSELL_CLICKED, {
      detail: type
    });
    window.dispatchEvent(evt);
  };

  var getMain = function getMain() {
    var tabIndex = !accessible ? '-1' : '0';
    return /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({}, customProperties, {
      tabIndex: tabIndex,
      theme: themeContext,
      fullWidth: fullWidth,
      border: border,
      borderRadius: borderRadius,
      "aria-live": "off",
      "aria-label": text,
      hasBoxShadow: hasBoxShadow
    }), showLeftImage && /*#__PURE__*/_react.default.createElement(LeftImage, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      placeHolderBackground: "none",
      src: imageUrl
    })), /*#__PURE__*/_react.default.createElement(Message, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      type: textType,
      color: textColor
    }, text), ctaText ? /*#__PURE__*/_react.default.createElement(LinkText, {
      onClick: handleOnClick
    }, ctaText) : null));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

UpsellBanner.propTypes = _UpsellBanner.default.PropTypes;
UpsellBanner.defaultProps = _UpsellBanner.default.DefaultProps;
var _default = UpsellBanner;
exports.default = _default;